import { IconProps } from "@/src/sb/business-layer/types"
import React from "react"

const SearchFunnelIcon = ({ width, height, size }: IconProps) => (
  <svg
    width={size ?? width ?? "12"}
    height={size ?? height ?? "12"}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.125 11.5H5.375C4.89175 11.5 4.5 11.1082 4.5 10.625V7.30437L1.25812 4.0625C1.09381 3.89916 1.00098 3.67731 1 3.44563V1.875C1 1.39175 1.39175 1 1.875 1H10.625C11.1082 1 11.5 1.39175 11.5 1.875V3.44563C11.499 3.67731 11.4062 3.89916 11.2419 4.0625L8 7.30437V10.625C8 11.1082 7.60825 11.5 7.125 11.5ZM1.875 1.87305V3.44367L5.375 6.94367V10.623H7.125V6.94367L10.625 3.44367V1.87305H1.875Z"
      fill="currentColor"
    />
  </svg>
)

export default SearchFunnelIcon
